import React from "react"
import l8n from "l8n"
import Icon from "antd/lib/icon"
import Tooltip from "antd/lib/tooltip"

function PasswordToggle(props) {
  const {onToggle, visible} = props
  return (
    <a
      href="#"
      style={{ lineHeight: '0' }}
      onClick={onToggle}
    >
      <Tooltip title={! visible ? l8n.p_show_password : l8n.p_hide_password}>
        <Icon type={! visible ? "eye-invisible" : "eye"} theme="outlined" />
      </Tooltip>
    </a>
  )
}

export default PasswordToggle


// WEBPACK FOOTER //
// ./src/components/CustomComponents/PasswordToggle/index.js